import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { globalConfig } from '../../config/config';
// const querystring = require('querystring');

export default class SelectListComponent extends Component
{
	constructor(props)
	{
		super(props);
		this.state = {
			entityName : "",
			keyColumnName : "",
			displayColumnName : "",
			valueFilter : "",
			entityObjects : [],
			valueId: "",
			optionItems:[],
			TypeId :"",
			handle :"",
			IdName :""
		}
	} 
	getData(){
		//var URL = 'http://os-dev.origosoftware.com:3000/'+this.props.entityName+'?filter[where]['+this.props.keyColumnName+']='+this.props.valueFilter
		//http://localhost:5100/code-catalog-data-service/get-data-list/system-code-values/systemCodeValueId/systemCodeValueValue/systemCodeId/234
		var URL = `${globalConfig.dataListCodesUrl}`+this.props.entityName+'/'+this.props.keyColumnName+'/'+
			this.props.displayColumnName + '/' + this.props.valueFilterColumnName  +'/'+ this.props.valueFilter
		console.log("URL: "+ URL);
		var initialentityObjects =[];
		axios.get(URL,globalConfig.hardcoded_header)
	.then(response =>{
		// console.log("Select:"+ response.data);
		initialentityObjects = response.data;
 		// console.log(initialentityObjects.length);
 		this.setState({entityObjects: initialentityObjects});

	}
	
	).catch(function (error) {
		console.log("Error:"+error);
	});
		
}
componentDidMount(){
	this.getData();
}
componentDidUpdate()
{
	// console.log('componentDidUpdate');
	// //this.getData();
}
	
	render(){
	//this.getData();
	// var i = 0;
	// var tempMap = "";
	// 		 for(i = 0;i < 5;i++){
	// 		  tempMap += "<option id=\"" + i+"\">Value = "+i+"</option>";
	// 	 }
	// console.log('rendering - ' + tempMap);

	return (
		<select class="form-control input-xlarge col-sm-8" id ={this.props.IdName} value ={this.props.TypeId} onChange ={this.props.handle}>
		<option id="0">Click to make a selection</option>
			{this.state.entityObjects.map( ( {idParam,valParam } ) => {
					return (
					<option id={idParam} value={+idParam}>{valParam}</option>
					)
			})}
			
		</select>
	)
	}
}